import React, { useEffect } from "react";
import warning from "../../../static/images/rbac_auth.svg";
import styles from "./unAuthorizedPage.module.scss";
import { useDispatch } from "react-redux";
import { setAccessError } from "../../../app/appSlice";
export const UnAuthorizedPage = () => {
  const dispatch = useDispatch();
  const defaultPageClick = () => {
    localStorage.removeItem('badReqMsg')
    dispatch(setAccessError(null))
    window.location='/'
  }
  useEffect(() => {
      dispatch(setAccessError(null))
  }, []);
  return (
    <>
      <div className={styles.main_content}>
        <img src={warning} alt="Warning" />
        <div className={`${styles.opps_txt}`}>Oops…</div>
        <div className={`${styles.opps_msg}`}>{(localStorage.getItem('badReqMsg'))?localStorage.getItem('badReqMsg'):'You are not authorized!'}</div>
        <button  data-testid="close" onClick={defaultPageClick} className={`${styles.opps_btn} defaultPageClick`}>
                  Home
                </button>
      </div>
    </>
  );
};
